import { configureErrorTrackingService } from "../exceptions";
import { sharedEnvironment } from "@akina/config";

export const errorTrackingService = configureErrorTrackingService(
  sharedEnvironment.environment,
  sharedEnvironment.sentryDsn,
);
